import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import View from './signin_view';
import { authenticate, getUserStatus, oauth2_login } from "../../APIs";
import { getUrlVars, parseJwt, errorHandler, validateEmail } from "../../utils";
import { setUserData } from "../../actions";
import { getAuthParams } from './utils';
import { isUSezpayRequest } from '../../utils/domainDetection';
class Signin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: "",
            email: "",
            password: "",
            loading: false,
            validateTemp: getUrlVars()["username"] && getUrlVars()["temp"],
            validationFailed: false,
            phoneOrEmail: 'email',
            usernameError: false,
            errorMessage: ""
        };

        this.signInFieldsInfo = [
            {
                title: "Email / Phone",
                field: "userName"
            },
            {
                title: "Password",
                field: "password"
            }
        ];

        this.signInHandler = this.signInHandler.bind(this);
        this.setInputField = this.setInputField.bind(this);
        this.loadingToggler = this.loadingToggler.bind(this);
        this.selectPhoneOrEmail = this.selectPhoneOrEmail.bind(this);
        this.clearUsernameError = this.clearUsernameError.bind(this);
    }
    selectPhoneOrEmail(option) {
        this.setState({
            phoneOrEmail: option,
            userName: ""
        })
    }
    setInputField = field => {
        if (field == 'userName') {
            return event => {
                if (this.state.phoneOrEmail == "phone") {
                    let phone = "";
                    for (let i = 0; i < event.target.value.length; i++) {
                        if (event.target.value.charAt(i) >= '0' && event.target.value.charAt(i) <= '9') {
                            phone += event.target.value.charAt(i);
                        }
                    }
                    this.setState({ userName: phone.substring(0, 10) });
                } else if (this.state.phoneOrEmail == "email") {
                    this.setState({ userName: event.target.value.toLowerCase() })
                } else {
                    this.setState({ [field]: event.target.value });
                }
            }
        } else {
            return event => {
                this.setState({ [field]: event.target.value });
            }
        }        
    };

    loadingToggler() {
        this.setState({
            loading: !this.state.loading
        })
    }

    signInHandler() {
        this.loadingToggler();
        let username = this.state.userName;
        if (this.state.phoneOrEmail == "phone") {
            username = "+1" + username;
        }
        
        // Use onSignInSuccess for complete authentication flow
        this.onSignInSuccess(username, this.state.password);
    }

    insertCodeQueryParams(urlStr, code) {
        let url = new URL(urlStr);
        let params = url.searchParams;
        params.append('code', code);
        return url.toString()
    }

    onSignInError = (err) => {
        if (err && err.response && err.response.data && err.response.data.code) {
            const code = err.response.data.code;
            if (code == "UserNotFoundException") {
                this.setState({
                    usernameError: true,
                    errorMessage: this.props.messagePool?.USERNAME_NOT_EXIST || "The username does not exist or is not verified. Please check your username and try again."
                });
            } else if (code == "NotAuthorizedException") {
                this.setState({
                    usernameError: true,
                    errorMessage: this.props.messagePool?.USERNAME_PASSWORD_WRONG || "The username or password is wrong"
                });
            } else {
                this.setState({
                    usernameError: true,
                    errorMessage: this.props.messagePool?.AUTHENTICATION_FAILED || "Authentication failed. Please try again."
                });
            }
        } else {
            this.setState({
                usernameError: true,
                errorMessage: this.props.messagePool?.USERNAME_PASSWORD_WRONG || "The username or password is wrong"
            });
        }
        // Stop the loading spinner when error occurs
        this.loadingToggler();
    }

    onSignInSuccess = async (username, password) => {
        const { base_url, redirect_uri, code_challenge, code_challenge_method } = getAuthParams()

        try {
            const response = await oauth2_login(base_url, code_challenge, code_challenge_method, username, password)
            
            if (response.data.requiresMFA) {
                console.log("🔧 FRONTEND SIGNIN - MFA required, redirecting to MFA page");

                // Use the original redirect_uri to preserve USezpay/MenuSifu context
                console.log("🔧 FRONTEND SIGNIN - Using original redirect_uri for MFA:", redirect_uri);

                // Always use /mfa - it will auto-detect branding from redirect_uri
                const mfaUrl = `/mfa?${new URLSearchParams({
                       redirect_uri: redirect_uri,
                       code_challenge: code_challenge,
                       code_challenge_method: code_challenge_method,
                   }).toString()}`;
                console.log("🔧 FRONTEND SIGNIN - Redirecting to:", mfaUrl);
                this.props.history.push(mfaUrl);
            } else if (response.data.newPasswordRequired) {
                alert(this.props.messagePool?.TEMP_PASSWORD_MESSAGE || "You are using the temporary password. Please reset your password for your account security.");
                const redirect_uri = getUrlVars()["redirect_uri"];
                this.props.history.push(`/changepassword/?username=${username}&redirect_uri=${redirect_uri}`);
            } else if (response.data.code) {
                console.log("🔧 FRONTEND SIGNIN - Authentication successful, redirecting with code");
                const code = response.data.code;
                window.location.href = insertCodeQueryParams(redirect_uri, code);
            } else {
                console.error("Unexpected response from oauth2_login:", response.data);
                this.setState({ error: "Unexpected response from authentication server" });
                this.loadingToggler();
            }
        } catch (error) {
            console.error("Error in onSignInSuccess:", error);
            this.onSignInError(error);
        }

        function insertCodeQueryParams(urlStr, code) {
            let url = new URL(urlStr);
            let params = url.searchParams;
            params.append('code', code);
            return url.toString()
        }
    }

    clearUsernameError = () => {
        this.setState({
            usernameError: false,
            errorMessage: ""
        });
    }

    componentDidMount() {
        if (getUrlVars()["username"] && getUrlVars()["temp"]) {
            authenticate(decodeURIComponent(getUrlVars()["username"]), getUrlVars()["temp"])
            .then(res => {
                if (res.data.newPasswordRequired) {
                    const redirect_uri = getUrlVars()["redirect_uri"];
                    this.props.history.push(`/changepassword/?username=${getUrlVars()["username"]}&temp=${getUrlVars()["temp"]}&redirect_uri=${redirect_uri}`);
                }
            })
            .catch(err => {
                getUserStatus(getUrlVars()["username"])
                .then(res => {
                    const { confirmed } = res.data;
                    if (confirmed) {
                        alert(this.props.messagePool?.ALREADY_CHANGED_PASSWORD || "You have already changed your temporary password. You will be redirected to the login page. Please use the forget password link if you cannot find your password.")
                        console.log(window.location.hostname);
                        this.props.history.push(`/${this.fromDomain}/login`);
                        this.setState({
                            validateTemp: false
                        })
                    } else {
                        errorHandler(err);
                        this.setState({
                            validateTemp: false,
                            validationFailed: true
                        })
                    }
                })
                .catch(err => {
                    errorHandler(err);
                    this.setState({
                        validateTemp: false,
                        validationFailed: true
                    })
                })
            })
        }
    }

    render() {
        const isUSezpay = isUSezpayRequest();
        return (
            <View signInFieldsInfo={this.signInFieldsInfo}
                    signInHandler={this.signInHandler}
                    setInputField={this.setInputField}
                    loadingToggler={this.loadingToggler}
                    state={this.state}
                    selectPhoneOrEmail={this.selectPhoneOrEmail}
                    onSignInSuccess={this.onSignInSuccess}
                    onSignInError={this.onSignInError}
                    clearUsernameError={this.clearUsernameError}
                    usernameError={this.state.usernameError}
                    errorMessage={this.state.errorMessage}
                    isUSezpay={isUSezpay}
                    {...this.state} />
        )
    }
}

function mapStateToProps(state){
    return{
        userState: state.userData
    }
}

export default withRouter(connect(mapStateToProps , {
    setUserData
})(Signin));